import { combineReducers } from 'redux'
import { firebaseStateReducer as firebase } from 'react-redux-firebase'

const item = (state={}, action) => {
  switch (action.type) {
    case 'ADD':
      return {
        ...state,
        [action.itemName]: state[action.itemName] ? state[action.itemName] + 1 : 1
      }
    case 'SUBTRACT':
      return {
        ...state,
        [action.itemName]: (state[action.itemName] &&  state[action.itemName] > 0) ? state[action.itemName]-1 : 0
      }
    default:
      return state
  }
}

const rootReducer = combineReducers({
  firebase,
  item
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducer.js